import "./ProductFeatureRow.css";
import { InView } from "@tennr/frontend/components/InView";
import { ProductFeatureCard } from "@tennr/frontend/components/ProductFeatureCard";
import type { FC } from "react";
import { LottieAnimation } from "@tennr/frontend/components/LottieAnimation";

interface Feature {
  id: number;
  title: string;
  heading: string;
  body: string;
  ctaText: string;
  imageAlt: string;
  expandedContent?: React.ReactNode;
  lottieSrc?: string;
  imgSrc?: string;
}

interface ProductFeatureRowProps {
  feature: Feature;
  isReversed: boolean;
  index: number;
}

export const ProductFeatureRow: FC<ProductFeatureRowProps> = ({ feature, isReversed, index }) => {
  const imageCard = (
    // <InView className="product-feature-image-wrapper">
    <div className="product-feature-image-wrapper">
      <div className="product-feature-image">
        {feature.lottieSrc ? (
          <LottieAnimation
            className={"product-feature-lottie-container"}
            src={feature.lottieSrc}
          />
        ) : feature.imgSrc ? (
          <img
            src={feature.imgSrc}
            alt={`Feature ${index + 1}: ${feature.heading}`}
            className="mobile-image"
            draggable={false}
          />
        ) : null}
      </div>
    </div>
    // </InView>
  );

  const contentCard = (
    <InView className="product-feature-content-wrapper">
      <ProductFeatureCard {...feature} />
    </InView>
  );

  return (
    <div className={`product-feature-row ${isReversed ? "reversed" : ""}`}>
      <div className="product-feature-row-inner">
        {isReversed ? (
          <>
            {contentCard}
            {imageCard}
          </>
        ) : (
          <>
            {imageCard}
            {contentCard}
          </>
        )}
      </div>
    </div>
  );
};
